/**
 * Calcule la date de début par défaut d'un contrat enfant en fonction du contrat parent.
 *
 * @param startDate - Date de début du contrat parent (ISO string)
 * @param endDate - Date de fin du contrat parent (ISO string)
 * @returns La date de début calculée (ISO string)
 *
 * @remarks
 * - Si le contrat parent est expiré (endDate <= maintenant) : retourne la startDate du parent telle quelle
 * - Sinon : retourne le maximum entre la date actuelle et la startDate du parent
 *   (pour éviter de créer un contrat avec une date de début dans le passé)
 */
export const defaultNewContractStartDate = ({
  startDate,
  endDate,
}: {
  startDate: string;
  endDate: string;
}): string => {
  return new Date(endDate).getTime() <= new Date().getTime()
    ? startDate
    : new Date(
        Math.max(new Date(startDate).getTime(), new Date().getTime()),
      ).toISOString();
};
